import { getStorageData } from "@/utils/storage";
import _get from "lodash.get";

const getMatchers = ({ roles, permissions, features, tier }) => {
  const storedUser = getStorageData("user");
  const storedCompany = getStorageData("company");

  const userPermissions = _get(storedUser, "acl.permissions", []);
  const userRoles = _get(storedUser, "acl.roles", []);

  const companyTier = _get(storedCompany, "tier", "");
  const tierSlug = companyTier.slug || companyTier;
  
  const companyFeatures = _get(storedCompany, "features", []);

  const matchers = [
    [{ rules: roles, match: userRoles }],
    [{ rules: permissions, match: userPermissions }],
    [{ rules: features, match: companyFeatures }],
    [{ rules: tier, match: [tierSlug] }]
  ];

  // console.log({
  //   AsObject: companyTier.slug,
  //   AsString: companyTier,
  //   Result: tierSlug,
  // });

  return matchers;
};

export default getMatchers;
